export default function CommunitySection() {
  return (
    <section className="py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-8 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              공동체
            </h2>
            
            <div className="bg-emerald-50 border-l-4 border-emerald-600 p-8 rounded-r-xl mb-10">
              <p className="text-2xl font-medium text-gray-800 leading-relaxed" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                우리는 기술을 가진 사람을
                <br />
                <span className="text-emerald-700 font-bold">"선생님"</span>이라고 부릅니다
              </p>
            </div>

            <p className="text-base text-gray-600 leading-relaxed mb-8">
              기술은 단순한 노동이 아닙니다. 오랜 시간 축적된 경험과 노하우, 그리고 한 사람의 삶이 담긴 소중한 자산입니다. 
              우리는 그 가치를 존중하며, 기술을 가진 모든 분들을 선생님으로 모십니다.
            </p>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-full">
                  <i className="ri-user-heart-line text-xl text-white"></i>
                </div>
                <span className="text-base text-gray-700 font-medium">기술 기반 자립</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-full">
                  <i className="ri-hand-heart-line text-xl text-white"></i>
                </div>
                <span className="text-base text-gray-700 font-medium">존중받는 노동 환경</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-full">
                  <i className="ri-team-line text-xl text-white"></i>
                </div>
                <span className="text-base text-gray-700 font-medium">함께 성장하는 공동체</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_fba42be472f48575b11dda9cfa710050_1a8417f1.jpg"
                alt="함께 작업하는 장면"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 w-48 h-48 bg-emerald-100 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}